import { createTheme } from '@mui/material/styles';

const theme = createTheme(); 

export const selectedButtonStyle1 = {
  backgroundColor: theme.palette.primary.main,
  height: "auto",
};

export const selectedButtonStyle2 = { height: "auto" };

export const buttonStyle1 = {
  width: "100%",
  textTransform: "initial",
  border: "1px solid transparent",
  borderRadius: "0",
  backgroundColor: "rgba(224,224,224,1)",
  fontSize: "12px",
  fontWeight: "600",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(224,224,224,1)",
    boxShadow: "none",
    color: "rgb(87, 87, 87)",
    border: "1px solid transparent",
  },
};

export const buttonStyle2 = {
  width: "100%",
  textTransform: "initial",
  border: "1px solid rgba(224,224,224,1)",
  backgroundColor: "transparent",
  borderRadius: "0",
  color: "rgb(87, 87, 87)",
  fontSize: "12px",
  fontWeight: "600",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#F0F0F0",
    boxShadow: "none",
    color: "rgb(87, 87, 87)",
    border: "1px solid transparent",
  },
};